import { AgentKind } from '~/types/types'

export function getAgentKindIcon(kind: AgentKind | null) {
  if (!kind) return ''
  const iconMap: Record<AgentKind, string> = {
    [AgentKind.FpTriage]: 'false-positive',
    [AgentKind.CvePrioritization]: 'cve-prioritisation',
    [AgentKind.AutofixAutopilot]: 'autofix'
  }
  return iconMap[kind]
}

export function getAgentKindName(kind: AgentKind | null) {
  if (!kind) return ''
  const nameMap: Record<AgentKind, string> = {
    [AgentKind.FpTriage]: 'False Positive Triage',
    [AgentKind.CvePrioritization]: 'CVE Prioritization',
    [AgentKind.AutofixAutopilot]: 'Autofix™ Autopilot'
  }
  return nameMap[kind]
}
